import React, { useState, useEffect, useCallback, useRef } from 'react';
import { useI18n } from '../context/i18n';
import './Integrations.css';

// ===== Iconos de sección =====
const CartIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="9" cy="21" r="1"/>
    <circle cx="20" cy="21" r="1"/>
    <path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"/>
  </svg>
);

const MailIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/>
    <polyline points="22,6 12,13 2,6"/>
  </svg>
);

const MegaphoneIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M3 11l18-5v12L3 13v-2z"/>
    <path d="M11.6 16.8a3 3 0 1 1-5.8-1.6"/>
  </svg>
);

const ExternalLinkIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"/>
    <polyline points="15 3 21 3 21 9"/>
    <line x1="10" y1="14" x2="21" y2="3"/>
  </svg>
);

// ===== Logos =====
const ShopifyLogo = () => (
  <div className="integration-logo shopify-logo">
    <svg width="32" height="32" viewBox="0 0 24 24" fill="currentColor">
      <path d="M15.337 3.415c-.193-.016-.418.008-.645.055-.154-.47-.386-.9-.715-1.196-.533-.478-1.198-.674-1.973-.552-.06-.093-.132-.18-.216-.26-.518-.495-1.393-.33-1.97.114-.493.38-.888.97-1.142 1.702-.402.155-.786.318-1.13.498l-.09-.085c-.638-.607-1.523-.856-2.315-.62-.827.247-1.474.95-1.726 1.876-.317 1.163-.07 2.637.678 4.015.05.09.108.18.166.268L3 19.584c-.054.244.076.493.308.588l7.08 2.885c.078.032.16.043.24.033a.493.493 0 00.233-.066c.013-.007 1.358-.785 1.358-.785L19.5 19.5l.01-.006a.493.493 0 00.24-.345l2.207-13.092a.483.483 0 00-.124-.415.503.503 0 00-.4-.178c-.04 0-4.89.127-6.097-.05zM12.5 5.79l-.604 1.863c-.507.156-.962.32-1.362.487.156-.662.45-1.186.858-1.518.195-.158.423-.247.663-.273.165.16.316.28.445.44zm-1.65-1.32c.083 0 .16.007.233.02-.315.12-.612.32-.868.595-.553.594-.978 1.522-1.082 2.71-.35.108-.693.22-1.012.337.25-1.686 1.372-3.662 2.73-3.662zm-1.85 13.11L7.17 8.663c.29-.094.597-.185.918-.27-.043.167-.073.34-.087.52-.073.875.166 1.936.674 3.012.505 1.07 1.193 1.984 1.923 2.597.175.148.353.275.532.383L9 17.58zm4.87-11.69l-1.77.546c-.052-.116-.117-.216-.194-.297-.29-.305-.72-.447-1.24-.41.08-.238.19-.46.328-.657.31-.443.742-.73 1.192-.77.338.408.584.904.684 1.588zm.68.978l-2.42.746c.168-.74.463-1.246.85-1.518.177-.123.378-.19.582-.197.15.375.247.675.288.97l.7-.001zm3.41 10.96l-4.61 2.06.51-3.04c.247.025.503.01.758-.05.87-.2 1.647-.755 2.213-1.51.06.034 2.11 1.263 2.11 1.263l-.98 1.277zm.69-3.06c-.465.64-1.11 1.095-1.823 1.26-.382.09-.752.08-1.08-.02a10.93 10.93 0 01-.95-.53c-.65-.42-1.257-1.03-1.74-1.765-.54-.82-.88-1.74-.956-2.58-.07-.76.073-1.4.387-1.85.132-.19.295-.35.48-.48L12.5 7.79l2.633-.81c.26.053.633.087 1.09.1 1.148.03 2.843-.05 4.357-.104l-1.81 10.74c-.75-.448-1.427-.86-1.92-1.15z"/>
    </svg>
  </div>
);

const VTEXLogo = () => (
  <div className="integration-logo vtex-logo">
    <svg width="32" height="32" viewBox="0 0 24 24" fill="currentColor">
      <text x="2" y="17" fontSize="12" fontWeight="bold" fontFamily="Arial">VT</text>
    </svg>
  </div>
);

const KlaviyoLogo = () => (
  <div className="integration-logo klaviyo-logo">
    <svg width="32" height="32" viewBox="0 0 24 24" fill="currentColor">
      <path d="M12 2L2 12l10 10 10-10L12 2zm0 3.5L18.5 12 12 18.5 5.5 12 12 5.5z"/>
    </svg>
  </div>
);

const OmnisendLogo = () => (
  <div className="integration-logo omnisend-logo">
    {/* Omnisend mark: stylized "O" in brand red (#EA3A50) on white circle */}
    <svg width="32" height="32" viewBox="0 0 24 24">
      <circle cx="12" cy="12" r="10" fill="#ffffff" />
      <circle cx="12" cy="12" r="5.5" fill="none" stroke="#EA3A50" strokeWidth="3" />
      <circle cx="12" cy="12" r="1.4" fill="#EA3A50" />
    </svg>
  </div>
);

const SalesforceLogo = () => (
  <div className="integration-logo salesforce-logo">
    <svg width="32" height="32" viewBox="0 0 24 24" fill="currentColor">
      <path d="M12 4c-2.21 0-4 1.79-4 4 0 .34.04.67.12 1H5c-1.66 0-3 1.34-3 3s1.34 3 3 3h.12c-.08.33-.12.66-.12 1 0 2.21 1.79 4 4 4s4-1.79 4-4c0-.34-.04-.67-.12-1H19c1.66 0 3-1.34 3-3s-1.34-3-3-3h-.12c.08-.33.12-.66.12-1 0-2.21-1.79-4-4-4z"/>
    </svg>
  </div>
);

const FacebookLogo = () => (
  <div className="integration-logo facebook-logo">
    <svg width="32" height="32" viewBox="0 0 24 24" fill="currentColor">
      <path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z"/>
    </svg>
  </div>
);

const GoogleAdsLogo = () => (
  <div className="integration-logo google-logo">
    <svg width="32" height="32" viewBox="0 0 24 24" fill="currentColor">
      <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-1 17.93c-3.95-.49-7-3.85-7-7.93 0-.62.08-1.21.21-1.79L9 15v1c0 1.1.9 2 2 2v1.93zm6.9-2.54c-.26-.81-1-1.39-1.9-1.39h-1v-3c0-.55-.45-1-1-1H8v-2h2c.55 0 1-.45 1-1V7h2c1.1 0 2-.9 2-2v-.41c2.93 1.19 5 4.06 5 7.41 0 2.08-.8 3.97-2.1 5.39z"/>
    </svg>
  </div>
);

// ===== URL del backend =====
const isLocalhost = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';
const API_URL = isLocalhost ? 'http://localhost:8081' : 'https://dashboard-dot-primeval-gear-417120.ue.r.appspot.com';
// Backend del chat (sirve los endpoints /klaviyo/*)
const CHAT_API_URL = isLocalhost ? 'http://localhost:8000' : 'https://mi-chat-892931479853.us-central1.run.app';

// ===== Datos de integraciones (sin Shopify, lo agregamos dinámicamente abajo) =====
const getStaticIntegrations = (language) => ({
  email: {
    title: language === 'en' ? 'Email Marketing' : 'Email Marketing',
    icon: MailIcon,
    tag: language === 'en' ? '(Optional)' : '(Opcional)',
    tagType: 'optional',
    items: [
      {
        id: 'sfmc',
        name: 'Salesforce Marketing Cloud',
        category: 'Email Marketing',
        logo: SalesforceLogo,
        connected: false,
        required: false,
        description: language === 'en'
          ? 'Integrate with SFMC to manage audiences and automations.'
          : 'Integra con SFMC para gestionar audiencias y automatizaciones.'
      }
    ]
  },
  advertising: {
    title: language === 'en' ? 'Advertising' : 'Publicidad',
    icon: MegaphoneIcon,
    tag: language === 'en' ? '(Optional)' : '(Opcional)',
    tagType: 'optional',
    items: [
      {
        id: 'facebook',
        name: 'Facebook Ads',
        category: language === 'en' ? 'Advertising' : 'Publicidad',
        logo: FacebookLogo,
        connected: false,
        required: false,
        description: language === 'en'
          ? 'Connect Facebook Ads to analyze campaign performance.'
          : 'Conecta Facebook Ads para analizar el rendimiento de tus campañas.'
      },
      {
        id: 'google',
        name: 'Google Ads',
        category: language === 'en' ? 'Advertising' : 'Publicidad',
        logo: GoogleAdsLogo,
        connected: false,
        required: false,
        description: language === 'en'
          ? 'Import Google Ads data to optimize ad spend.'
          : 'Importa datos de Google Ads para optimizar tu inversión publicitaria.'
      }
    ]
  }
});

// ===== Card de integración (genérica, sin lógica especial) =====
const IntegrationCard = ({ integration, language }) => {
  const LogoComponent = integration.logo;
  return (
    <div className="integration-card">
      <div className="integration-card-header">
        <LogoComponent />
        <div className="integration-card-info">
          <div className="integration-card-title-row">
            <h3>{integration.name}</h3>
            {integration.required && (
              <span className="integration-badge required">{language === 'en' ? 'Required' : 'Requerido'}</span>
            )}
          </div>
          <span className="integration-category">{integration.category}</span>
        </div>
        <div className={`integration-status ${integration.connected ? 'connected' : 'disconnected'}`}>
          <span className="status-dot"></span>
          <span className="status-text">{integration.connected ? (language === 'en' ? 'Connected' : 'Conectado') : (language === 'en' ? 'Disconnected' : 'Desconectado')}</span>
        </div>
      </div>
      <p className="integration-description">{integration.description}</p>
      <button className="integration-connect-btn">
        {language === 'en' ? 'Connect' : 'Conectar'}
        <ExternalLinkIcon />
      </button>
    </div>
  );
};

// ===== Card especial de Shopify (con fetch del estado real) =====

const ShopifyCard = ({ language, companyId }) => {
  const [loading, setLoading] = useState(true);
  const [status, setStatus] = useState({ connected: false });
  const [shopDomain, setShopDomain] = useState('');
  const [error, setError] = useState(null);
  const isFetchingRef = useRef(false);
  const abortRef = useRef(null);
  const debounceRef = useRef(null);

  // fetchStatus NO depende de language (era bug: recreaba la función en cada cambio)
  const fetchStatus = useCallback(async ({ silent = false } = {}) => {
    if (!companyId) {
      setLoading(false);
      return null;
    }
    if (isFetchingRef.current) return null;
    isFetchingRef.current = true;

    // Cancelar petición anterior si existe
    if (abortRef.current) abortRef.current.abort();
    const controller = new AbortController();
    abortRef.current = controller;

    // Timeout de 8 segundos
    const timeoutId = setTimeout(() => controller.abort(), 8000);

    if (!silent) setLoading(true);
    setError(null);

    try {
      const res = await fetch(
        `${API_URL}/shopify/status?company=${encodeURIComponent(companyId)}&t=${Date.now()}`,
        {
          headers: { 'Content-Type': 'application/json' },
          cache: 'no-store',
          signal: controller.signal
        }
      );
      if (!res.ok) throw new Error(`HTTP ${res.status}`);
      const data = await res.json();
      setStatus(data);
      return data;
    } catch (err) {
      if (err.name === 'AbortError') {
        console.warn('Shopify status fetch timed out or was cancelled');
        setError('Connection timed out');
      } else {
        console.error('Error fetching Shopify status:', err);
        setError('Could not load status');
      }
      return null;
    } finally {
      clearTimeout(timeoutId);
      setLoading(false);
      isFetchingRef.current = false;
    }
  }, [companyId]); // Solo depende de companyId, NO de language

  // 1) Fetch inicial cuando companyId esté disponible
  useEffect(() => {
    fetchStatus();
  }, [fetchStatus]);

  // 2) Detectar regreso del OAuth (?shopify=connected) y hacer polling corto
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    if (params.get('shopify') !== 'connected') return;

    params.delete('shopify');
    const newSearch = params.toString();
    const newUrl = window.location.pathname + (newSearch ? `?${newSearch}` : '') + window.location.hash;
    window.history.replaceState({}, '', newUrl);

    let cancelled = false;
    const delays = [500, 2000, 5000];

    const poll = async () => {
      for (const delay of delays) {
        if (cancelled) return;
        await new Promise((r) => setTimeout(r, delay));
        if (cancelled) return;
        const data = await fetchStatus({ silent: true });
        if (data?.connected) return;
      }
    };
    poll();

    return () => { cancelled = true; };
  }, [fetchStatus]);

  // 3) Refetch cuando la pestaña recupera visibilidad (CON DEBOUNCE de 500ms)
  useEffect(() => {
    const debouncedFetch = () => {
      if (debounceRef.current) clearTimeout(debounceRef.current);
      debounceRef.current = setTimeout(() => {
        fetchStatus({ silent: true });
      }, 500);
    };

    const onVisibility = () => {
      if (document.visibilityState === 'visible') debouncedFetch();
    };

    // Solo visibilitychange, NO focus (focus dispara en cada click en la ventana)
    document.addEventListener('visibilitychange', onVisibility);

    return () => {
      document.removeEventListener('visibilitychange', onVisibility);
      if (debounceRef.current) clearTimeout(debounceRef.current);
    };
  }, [fetchStatus]);

  // Cleanup AbortController al desmontar
  useEffect(() => {
    return () => {
      if (abortRef.current) abortRef.current.abort();
    };
  }, []);

  const handleConnect = () => {
    let domain = shopDomain.trim().toLowerCase();
    if (!domain) return;
    domain = domain.replace(/^https?:\/\//, '').replace(/\/$/, '');
    if (!domain.includes('.myshopify.com')) {
      domain = `${domain.split('.')[0]}.myshopify.com`;
    }
    const enterpriseId = companyId || 'DEMO';
    const url = `https://auth.upsellerate.co/install/shopify?shop=${encodeURIComponent(domain)}&enterprise_id=${encodeURIComponent(enterpriseId)}`;
    window.location.replace(url);
    return;
  };

  const handleRefresh = () => fetchStatus();

  // Textos según idioma (fuera del callback para no crear dependencia)
  const t = {
    checking: language === 'en' ? 'Checking...' : 'Verificando...',
    connected: language === 'en' ? 'Connected' : 'Conectado',
    disconnected: language === 'en' ? 'Disconnected' : 'Desconectado',
    checkingBtn: language === 'en' ? 'Checking status...' : 'Verificando estado...',
    retry: language === 'en' ? 'Retry' : 'Reintentar',
    installed: language === 'en' ? 'Installed: ' : 'Instalado: ',
    connect: language === 'en' ? 'Connect' : 'Conectar',
    placeholder: language === 'en' ? 'your-store.myshopify.com' : 'tu-tienda.myshopify.com',
    required: language === 'en' ? 'Required' : 'Requerido',
    description: language === 'en'
      ? 'Sync products, orders, and customers from your Shopify store.'
      : 'Sincroniza productos, pedidos y clientes desde tu tienda Shopify.',
    noCompany: language === 'en'
      ? 'Select an active account to manage integrations.'
      : 'Selecciona una cuenta activa para administrar integraciones.',
  };

  return (
    <div className="integration-card">
      <div className="integration-card-header">
        <ShopifyLogo />
        <div className="integration-card-info">
          <div className="integration-card-title-row">
            <h3>Shopify</h3>
            <span className="integration-badge required">{t.required}</span>
          </div>
          <span className="integration-category">E-commerce</span>
        </div>
        <div className={`integration-status ${status.connected ? 'connected' : 'disconnected'}`}>
          <span className="status-dot"></span>
          <span className="status-text">
            {loading ? t.checking : status.connected ? t.connected : t.disconnected}
          </span>
        </div>
      </div>

      <p className="integration-description">{t.description}</p>

      {/* Estado: sin companyId todavía */}
      {!companyId && (
        <button className="integration-connect-btn" disabled>
          {t.noCompany}
        </button>
      )}

      {/* Estado: cargando (con companyId) */}
      {companyId && loading && (
        <button className="integration-connect-btn" disabled>
          {t.checkingBtn}
        </button>
      )}

      {/* Estado: error */}
      {companyId && !loading && error && (
        <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginTop: 8 }}>
          <div style={{ color: '#c00', fontSize: 13 }}>{error}</div>
          <button
            onClick={handleRefresh}
            style={{
              padding: '4px 10px',
              border: '1px solid #ccc',
              borderRadius: 6,
              fontSize: 12,
              background: '#fff',
              cursor: 'pointer'
            }}
          >
            {t.retry}
          </button>
        </div>
      )}

      {/* Estado: conectado */}
      {companyId && !loading && !error && status.connected && (
        <div style={{ marginTop: 8 }}>
          <div style={{ fontSize: 13, color: '#0a7', fontWeight: 600 }}>
            ✓ {status.shop_domain}
          </div>
          {status.installed_at && (
            <div style={{ fontSize: 12, color: '#888', marginTop: 4 }}>
              {t.installed}
              {new Date(status.installed_at).toLocaleDateString()}
            </div>
          )}
        </div>
      )}

      {/* Estado: no conectado */}
      {companyId && !loading && !error && !status.connected && (
        <div style={{ display: 'flex', gap: 8, marginTop: 8 }}>
          <input
            type="text"
            value={shopDomain}
            onChange={(e) => setShopDomain(e.target.value)}
            placeholder={t.placeholder}
            style={{
              flex: 1,
              padding: '8px 12px',
              border: '1px solid #ccc',
              borderRadius: 6,
              fontSize: 14
            }}
            onKeyDown={(e) => { if (e.key === 'Enter') handleConnect(); }}
          />
          <button
            className="integration-connect-btn"
            onClick={handleConnect}
            disabled={!shopDomain.trim()}
            style={{ whiteSpace: 'nowrap' }}
          >
            {t.connect}
            <ExternalLinkIcon />
          </button>
        </div>
      )}
    </div>
  );
};

// ===== Card especial de Klaviyo (estado real + guardado de API key) =====

const KlaviyoCard = ({ language, companyId }) => {
  const [loading, setLoading] = useState(true);
  const [status, setStatus] = useState({ connected: false });
  const [apiKey, setApiKey] = useState('');
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState(null);
  const [showInput, setShowInput] = useState(false);

  const fetchStatus = useCallback(async () => {
    if (!companyId) { setLoading(false); return; }
    setLoading(true);
    setError(null);
    try {
      const res = await fetch(
        `${CHAT_API_URL}/klaviyo/status?company=${encodeURIComponent(companyId)}&t=${Date.now()}`,
        { headers: { 'Content-Type': 'application/json' }, cache: 'no-store' }
      );
      if (!res.ok) throw new Error(`HTTP ${res.status}`);
      setStatus(await res.json());
    } catch (err) {
      console.error('Error fetching Klaviyo status:', err);
      setError(language === 'en' ? 'Could not load status' : 'No se pudo cargar el estado');
    } finally {
      setLoading(false);
    }
  }, [companyId]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => { fetchStatus(); }, [fetchStatus]);

  const handleSave = async () => {
    const key = apiKey.trim();
    if (!key || saving) return;
    setSaving(true);
    setError(null);
    try {
      const res = await fetch(`${CHAT_API_URL}/klaviyo/api-key`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ company_id: companyId, api_key: key }),
      });
      const body = await res.json().catch(() => ({}));
      if (!res.ok) {
        const detail = body?.detail;
        const msg = (detail && (detail.message || detail)) ||
          (language === 'en' ? 'Invalid API key.' : 'Clave de API inválida.');
        throw new Error(typeof msg === 'string' ? msg : JSON.stringify(msg));
      }
      setApiKey('');
      setShowInput(false);
      await fetchStatus();
    } catch (err) {
      setError(err.message);
    } finally {
      setSaving(false);
    }
  };

  const t = {
    checking: language === 'en' ? 'Checking...' : 'Verificando...',
    connected: language === 'en' ? 'Connected' : 'Conectado',
    disconnected: language === 'en' ? 'Disconnected' : 'Desconectado',
    connect: language === 'en' ? 'Connect' : 'Conectar',
    save: saving ? (language === 'en' ? 'Validating...' : 'Validando...') : (language === 'en' ? 'Save' : 'Guardar'),
    cancel: language === 'en' ? 'Cancel' : 'Cancelar',
    placeholder: language === 'en' ? 'Klaviyo Private API Key (pk_...)' : 'Clave privada de API de Klaviyo (pk_...)',
    help: language === 'en'
      ? 'Create a Private API Key in Klaviyo (Settings > API Keys) with read/write access to Segments, Profiles and Campaigns.'
      : 'Crea una clave privada en Klaviyo (Settings > API Keys) con acceso de lectura/escritura a Segmentos, Perfiles y Campañas.',
    description: language === 'en'
      ? 'Sync segments and email marketing campaigns with Klaviyo.'
      : 'Sincroniza segmentos y campañas de email marketing con Klaviyo.',
    noCompany: language === 'en'
      ? 'Select an active account to manage integrations.'
      : 'Selecciona una cuenta activa para administrar integraciones.',
  };

  return (
    <div className="integration-card">
      <div className="integration-card-header">
        <KlaviyoLogo />
        <div className="integration-card-info">
          <div className="integration-card-title-row">
            <h3>Klaviyo</h3>
          </div>
          <span className="integration-category">Email Marketing</span>
        </div>
        <div className={`integration-status ${status.connected ? 'connected' : 'disconnected'}`}>
          <span className="status-dot"></span>
          <span className="status-text">
            {loading ? t.checking : status.connected ? t.connected : t.disconnected}
          </span>
        </div>
      </div>

      <p className="integration-description">{t.description}</p>

      {!companyId && (
        <button className="integration-connect-btn" disabled>{t.noCompany}</button>
      )}

      {companyId && loading && (
        <button className="integration-connect-btn" disabled>{t.checking}</button>
      )}

      {companyId && !loading && status.connected && (
        <div style={{ marginTop: 8, fontSize: 13, color: '#0a7', fontWeight: 600 }}>
          ✓ {t.connected}
        </div>
      )}

      {companyId && !loading && !status.connected && !showInput && (
        <button className="integration-connect-btn" onClick={() => setShowInput(true)}>
          {t.connect}
          <ExternalLinkIcon />
        </button>
      )}

      {companyId && !loading && !status.connected && showInput && (
        <div style={{ marginTop: 8 }}>
          <div style={{ display: 'flex', gap: 8 }}>
            <input
              type="password"
              value={apiKey}
              onChange={(e) => setApiKey(e.target.value)}
              placeholder={t.placeholder}
              autoComplete="off"
              style={{ flex: 1, padding: '8px 12px', border: '1px solid #ccc', borderRadius: 6, fontSize: 14 }}
              onKeyDown={(e) => { if (e.key === 'Enter') handleSave(); }}
            />
            <button
              className="integration-connect-btn"
              onClick={handleSave}
              disabled={!apiKey.trim() || saving}
              style={{ whiteSpace: 'nowrap' }}
            >
              {t.save}
            </button>
            <button
              onClick={() => { setShowInput(false); setApiKey(''); setError(null); }}
              disabled={saving}
              style={{ padding: '4px 10px', border: '1px solid #ccc', borderRadius: 6, fontSize: 12, background: '#fff', cursor: 'pointer' }}
            >
              {t.cancel}
            </button>
          </div>
          <div style={{ fontSize: 12, color: '#888', marginTop: 6 }}>{t.help}</div>
        </div>
      )}

      {companyId && !loading && error && (
        <div style={{ color: '#c00', fontSize: 13, marginTop: 8 }}>{error}</div>
      )}
    </div>
  );
};

// ===== Card especial de Omnisend (estado real + guardado de API key) =====

const OmnisendCard = ({ language, companyId }) => {
  const [loading, setLoading] = useState(true);
  const [status, setStatus] = useState({ connected: false });
  const [apiKey, setApiKey] = useState('');
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState(null);
  const [showInput, setShowInput] = useState(false);

  const fetchStatus = useCallback(async () => {
    if (!companyId) { setLoading(false); return; }
    setLoading(true);
    setError(null);
    try {
      const res = await fetch(
        `${CHAT_API_URL}/omnisend/status?company=${encodeURIComponent(companyId)}&t=${Date.now()}`,
        { headers: { 'Content-Type': 'application/json' }, cache: 'no-store' }
      );
      if (!res.ok) throw new Error(`HTTP ${res.status}`);
      setStatus(await res.json());
    } catch (err) {
      console.error('Error fetching Omnisend status:', err);
      setError(language === 'en' ? 'Could not load status' : 'No se pudo cargar el estado');
    } finally {
      setLoading(false);
    }
  }, [companyId]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => { fetchStatus(); }, [fetchStatus]);

  const handleSave = async () => {
    const key = apiKey.trim();
    if (!key || saving) return;
    setSaving(true);
    setError(null);
    try {
      const res = await fetch(`${CHAT_API_URL}/omnisend/api-key`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ company_id: companyId, api_key: key }),
      });
      const body = await res.json().catch(() => ({}));
      if (!res.ok) {
        const detail = body?.detail;
        const msg = (detail && (detail.message || detail)) ||
          (language === 'en' ? 'Invalid API key.' : 'Clave de API inválida.');
        throw new Error(typeof msg === 'string' ? msg : JSON.stringify(msg));
      }
      setApiKey('');
      setShowInput(false);
      await fetchStatus();
    } catch (err) {
      setError(err.message);
    } finally {
      setSaving(false);
    }
  };

  const t = {
    checking: language === 'en' ? 'Checking...' : 'Verificando...',
    connected: language === 'en' ? 'Connected' : 'Conectado',
    disconnected: language === 'en' ? 'Disconnected' : 'Desconectado',
    connect: language === 'en' ? 'Connect' : 'Conectar',
    save: saving ? (language === 'en' ? 'Validating...' : 'Validando...') : (language === 'en' ? 'Save' : 'Guardar'),
    cancel: language === 'en' ? 'Cancel' : 'Cancelar',
    placeholder: language === 'en' ? 'Omnisend API Key' : 'Clave de API de Omnisend',
    help: language === 'en'
      ? 'Create an API Key in Omnisend (Store settings > API keys) with read/write access to Segments, Contacts and Campaigns.'
      : 'Crea una clave de API en Omnisend (Store settings > API keys) con acceso de lectura/escritura a Segmentos, Contactos y Campañas.',
    description: language === 'en'
      ? 'Sync segments and email marketing campaigns with Omnisend.'
      : 'Sincroniza segmentos y campañas de email marketing con Omnisend.',
    noCompany: language === 'en'
      ? 'Select an active account to manage integrations.'
      : 'Selecciona una cuenta activa para administrar integraciones.',
  };

  return (
    <div className="integration-card">
      <div className="integration-card-header">
        <OmnisendLogo />
        <div className="integration-card-info">
          <div className="integration-card-title-row">
            <h3>Omnisend</h3>
          </div>
          <span className="integration-category">Email Marketing</span>
        </div>
        <div className={`integration-status ${status.connected ? 'connected' : 'disconnected'}`}>
          <span className="status-dot"></span>
          <span className="status-text">
            {loading ? t.checking : status.connected ? t.connected : t.disconnected}
          </span>
        </div>
      </div>

      <p className="integration-description">{t.description}</p>

      {!companyId && (
        <button className="integration-connect-btn" disabled>{t.noCompany}</button>
      )}

      {companyId && loading && (
        <button className="integration-connect-btn" disabled>{t.checking}</button>
      )}

      {companyId && !loading && status.connected && (
        <div style={{ marginTop: 8, fontSize: 13, color: '#0a7', fontWeight: 600 }}>
          ✓ {t.connected}
        </div>
      )}

      {companyId && !loading && !status.connected && !showInput && (
        <button className="integration-connect-btn" onClick={() => setShowInput(true)}>
          {t.connect}
          <ExternalLinkIcon />
        </button>
      )}

      {companyId && !loading && !status.connected && showInput && (
        <div style={{ marginTop: 8 }}>
          <div style={{ display: 'flex', gap: 8 }}>
            <input
              type="password"
              value={apiKey}
              onChange={(e) => setApiKey(e.target.value)}
              placeholder={t.placeholder}
              autoComplete="off"
              style={{ flex: 1, padding: '8px 12px', border: '1px solid #ccc', borderRadius: 6, fontSize: 14 }}
              onKeyDown={(e) => { if (e.key === 'Enter') handleSave(); }}
            />
            <button
              className="integration-connect-btn"
              onClick={handleSave}
              disabled={!apiKey.trim() || saving}
              style={{ whiteSpace: 'nowrap' }}
            >
              {t.save}
            </button>
            <button
              onClick={() => { setShowInput(false); setApiKey(''); setError(null); }}
              disabled={saving}
              style={{ padding: '4px 10px', border: '1px solid #ccc', borderRadius: 6, fontSize: 12, background: '#fff', cursor: 'pointer' }}
            >
              {t.cancel}
            </button>
          </div>
          <div style={{ fontSize: 12, color: '#888', marginTop: 6 }}>{t.help}</div>
        </div>
      )}

      {companyId && !loading && error && (
        <div style={{ color: '#c00', fontSize: 13, marginTop: 8 }}>{error}</div>
      )}
    </div>
  );
};

// ===== Sección genérica =====
const IntegrationSection = ({ section, language, children }) => {
  const IconComponent = section.icon;
  return (
    <div className="integration-section">
      <div className="integration-section-header">
        <div className="integration-section-title">
          <IconComponent />
          <h2>{section.title}</h2>
          <span className={`integration-section-tag ${section.tagType}`}>
            {section.tag}
          </span>
        </div>
      </div>
      <div className="integration-cards-grid">
        {children || section.items.map(item => (
          <IntegrationCard key={item.id} integration={item} language={language} />
        ))}
      </div>
    </div>
  );
};

// ===== Componente principal =====
export const getIntegrationCompanyId = (companyInfo) =>
  companyInfo?.company_id || companyInfo?.CompanyId || '';

const Integrations = ({ companyInfo }) => {
  const { language } = useI18n();
  const staticIntegrations = getStaticIntegrations(language);
  const companyId = getIntegrationCompanyId(companyInfo);

  // Sección de e-commerce con Shopify dinámico
  const ecommerceSection = {
    title: language === 'en' ? 'E-commerce Platforms' : 'Plataformas E-commerce',
    icon: CartIcon,
    tag: language === 'en' ? '(At least one required)' : '(Al menos una requerida)',
    tagType: 'required'
  };

  const vtexItem = {
    id: 'vtex',
    name: 'VTEX',
    category: 'E-commerce',
    logo: VTEXLogo,
    connected: false,
    required: true,
    description: language === 'en'
      ? 'Connect your VTEX platform to import sales and catalog data.'
      : 'Conecta tu plataforma VTEX para importar datos de ventas y catálogo.'
  };

  return (
    <div className="integrations-page">
      <div className="integrations-header">
        <div className="integrations-header-left">
          <h1>{language === 'en' ? 'Integrations' : 'Integraciones'}</h1>
          <p>{language === 'en' ? 'Connect your platforms to sync data automatically' : 'Conecta tus plataformas para sincronizar datos automáticamente'}</p>
        </div>
      </div>

      <div className="integrations-content">
        {/* E-commerce con Shopify dinámico */}
        <IntegrationSection section={ecommerceSection} language={language}>
          <ShopifyCard language={language} companyId={companyId} />
          <IntegrationCard integration={vtexItem} language={language} />
        </IntegrationSection>

        {/* Email Marketing con Klaviyo dinámico */}
        <IntegrationSection section={staticIntegrations.email} language={language}>
          <KlaviyoCard language={language} companyId={companyId} />
          <OmnisendCard language={language} companyId={companyId} />
          {staticIntegrations.email.items.map(item => (
            <IntegrationCard key={item.id} integration={item} language={language} />
          ))}
        </IntegrationSection>

        {/* Resto de secciones (estáticas por ahora) */}
        <IntegrationSection section={staticIntegrations.advertising} language={language} />
      </div>
    </div>
  );
};

export default Integrations;
